/*
 * Generated by orval v3.2.3 🍺
 * Do not edit manually.
 * BFF Customers Api
 * OpenAPI spec version: v6
 */

export type Author = 'CUSTOMER' | 'PROVIDER ' | 'WORKER';

export const Author = {
  CUSTOMER: 'CUSTOMER' as Author,
  PROVIDER: 'PROVIDER' as Author,
  WORKER: 'WORKER' as Author,
};
